export default {
  login: "AlmogWer",
  id: 87434394,
  node_id: "MDQ6VXNlcjg3NDM0Mzk0",
  avatar_url: "https://avatars.githubusercontent.com/u/87434394?v=4",
  gravatar_id: "",
  url: "https://api.github.com/users/AlmogWer",
  html_url: "https://github.com/AlmogWer",
  followers_url: "https://api.github.com/users/AlmogWer/followers",
  following_url: "https://api.github.com/users/AlmogWer/following{/other_user}",
  gists_url: "https://api.github.com/users/AlmogWer/gists{/gist_id}",
  starred_url: "https://api.github.com/users/AlmogWer/starred{/owner}{/repo}",
  subscriptions_url: "https://api.github.com/users/AlmogWer/subscriptions",
  organizations_url: "https://api.github.com/users/AlmogWer/orgs",
  repos_url: "https://api.github.com/users/AlmogWer/repos",
  events_url: "https://api.github.com/users/AlmogWer/events{/privacy}",
  received_events_url: "https://api.github.com/users/AlmogWer/received_events",
  type: "User",
  site_admin: false,
  name: "Almog Wertzberger",
  company: "Check Point Software Technologies LTD",
  blog: "www.almogwer.dev",
  location: "Israel",
  email: "Almogish@gmail.com",
  hireable: null,
  bio: "I love React!👩🏽‍💻",
  twitter_username: null,
  public_repos: 45,
  public_gists: 13,
  followers: 36,
  following: 4,
  created_at: "2021-07-14T14:41:10Z",
  updated_at: "2021-09-12T08:52:03Z",
};
